import HttpRequest from './HttpRequest';
import generateEndpoint from '../utils/generateEndpoint';

export default class BannerService extends HttpRequest {
  static endpoint = 'banners';

  static async getAll() {
    this.endpoint = generateEndpoint('banners');
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'banners';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'banners';
    const response = await this.post(data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'banners';
    const response = await this.delete(id);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'banners';
    const response = await this.put(id, data);
    return response;
  }

  static async uploadImage(data) {
    this.endpoint = 'banners/create-image';
    const response = await this.post(data);
    return response;
  }

  static async deleteImage(data) {
    this.endpoint = 'banners/delete-image';
    const response = await this.delete(data);
    return response;
  }
}
